import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ez-infobox',
  imports: [],
  templateUrl: './infobox.component.html',
  styleUrl: './infobox.component.scss',
})
export class InfoboxComponent {
  @Input()
  @HostBinding('style.background')
  background: string;

  @Input()
  @HostBinding('style.color')
  color: string;
}
